var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProgress = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13 4.25H1.25v7.5H13A1.75 1.75 0 0 0 14.75 10V6A1.75 1.75 0 0 0 13 4.25zM2.75 6.75v-1H13a.25.25 0 0 1 .25.25v4a.25.25 0 0 1-.25.25H2.75v-1h7.5v-2.5h-7.5z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgProgress);
export default ForwardRef;